import { FC, SVGProps } from 'react';

export const RadioCheckedIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
		<rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeOpacity="0.3"/>
		<circle cx="9" cy="9" r="5" fill="currentColor"/>
	</svg>
);
